import React, { useEffect } from 'react';
import ThColorPicker from '../../forms/th-color-picker';
import InputTextArea from '../../forms/th-iput-text-area';
import ThInputText from '../../forms/th-input-text';
import Button from '../../UI/button';
import ModalCustom from '../../UI/modal';
import { Form } from 'react-bootstrap';
import ThDropdown from '../../forms/th-dropdown';
import cn from 'classnames';
import ThInputsDate from '../../forms/th-inputs-date';
import { CommonBoardItemProps } from '../../types/itinerary-types';
import { useAddDay } from './use-add-day';
import { useTrip } from '../../contexts/trip-context';

type Props = {
  dataCards?: CommonBoardItemProps[];
  show: boolean;
  handleClose: () => void;
  handleAddDay?: (data: {
    color: string;
    title: string;
    description: string;
  }) => void;
};

const AddDayModal = ({ show, handleClose, handleAddDay, dataCards }: Props) => {
  const { trip, selectedItinerary } = useTrip();

  // Calculate day count from selected itinerary or fallback to dataCards
  const dayCount = selectedItinerary?.days?.length || dataCards?.length || 0;

  const [day, setDay] = React.useState<boolean>(false);
  const [color, setColor] = React.useState<string>('#842234');
  const [title] = React.useState<string>(`Day ${dayCount + 1}`);
  const [description, setDescription] = React.useState<string>('');
  const [dayNumber, setDayNumber] = React.useState<string>(`${dayCount + 1}`);
  const tripId = trip?.id || '';
  const itineraryId = selectedItinerary?.id || '';

  const { isSubmitting, error, handleSubmitWithData } = useAddDay(
    tripId,
    itineraryId,
    () => {
      handleClose();
    }
  );

  const onSubmit = () => {
    const dayData = {
      color,
      title,
      description
    };

    // Call the hook's submit and optionally the parent's handleAddDay
    handleSubmitWithData(dayData);
    if (handleAddDay) {
      handleAddDay(dayData);
    }
  };

  const handleDayNumberChange = (value: string) => {
    // Only allow positive integers from 1-50
    const numValue = parseInt(value, 10);

    // If empty string, allow it (user might be clearing the field)
    if (value === '') {
      setDayNumber('');
      return;
    }

    // Only allow valid numbers between 1 and 50
    if (
      !isNaN(numValue) &&
      numValue >= 1 &&
      numValue <= 50 &&
      value === numValue.toString()
    ) {
      setDayNumber(value);
    }
  };

  useEffect(() => {
    console.log('datacards', dataCards);
  }, [dataCards]);

  return (
    <ModalCustom
      title='Add a new day to your trip'
      show={show}
      onHide={handleClose}
    >
      <Form>
        <Form.Group>
          <Form.Label>
            <div className='add-day-label'>
              Select<span className='text-primary'>*</span> :{' '}
              <div className='choose-day-date'>
                <span
                  className={cn({ active: !day })}
                  onClick={() => setDay(!day)}
                >
                  Day
                </span>
                <span
                  className={cn({ active: day })}
                  onClick={() => setDay(!day)}
                >
                  Date
                </span>
              </div>
            </div>
          </Form.Label>
          {!day ? (
            <ThInputText
              label='Day Number'
              labelShow={false}
              value={dayNumber}
              onChange={handleDayNumberChange}
              placeholder='Enter day number (1-50)'
              required={true}
              maxLength={2}
            />
          ) : (
            <ThInputsDate />
          )}
        </Form.Group>
        <ThColorPicker
          initialColor={color}
          onChange={(color) => setColor(color)}
        />
        <ThDropdown
          id='add-activity-numbering'
          label='Add Activity Numbering'
          optionsArrays={[
            [
              { id: 'yes', name: 'Yes' },
              { id: 'no', name: 'No' }
            ]
          ]}
          required={false}
        />
        <InputTextArea
          label='Description'
          placeholder='Enter here'
          value={description}
          onChange={setDescription}
          required={false}
          rowCount={3}
        />
        <Button
          variant='primary'
          px={50}
          className='mx-auto'
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Adding...' : 'Add Day'}
        </Button>
        {error && <div className='text-danger mt-2 text-center'>{error}</div>}
      </Form>
    </ModalCustom>
  );
};
export default AddDayModal;
